export default class SelectListModel {
  constructor(public Key: string, public Value: string) {}
}
